/* section-sec-safety-cta.js — parallax ảnh nền theo cuộn (clone cơ chế đo máy Coterie 260712:
   offset = -rect.top × 0.111, mốc 0 khi mép section chạm đỉnh viewport, biên ±10% chiều cao khung).
   Ảnh được CSS phóng 120% + top -10% nên dịch chuyển không bao giờ hở mép.
   Desktop-only (≥1024) + tôn trọng prefers-reduced-motion; rAF + chỉ chạy khi section trong màn. */
(function () {
  'use strict';

  var RATE = 0.111; // đo Coterie: Δoffset/Δscroll ≈ 0.11

  function initCtaParallax(fig) {
    if (!fig || fig.dataset.ctaParallax === '1') return;
    fig.dataset.ctaParallax = '1';
    var img = fig.querySelector('.sec-safety-cta__img');
    if (!img) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktop = window.matchMedia('(min-width: 1024px)');
    var visible = false;
    var ticking = false;

    function apply() {
      ticking = false;
      if (!visible || reduced.matches || !desktop.matches) {
        img.style.transform = '';
        return;
      }
      var rect = fig.getBoundingClientRect();
      var limit = rect.height * 0.1; // headroom 10% (CSS phóng 120%)
      var offset = Math.max(-limit, Math.min(limit, -rect.top * RATE));
      img.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(apply);
      }
    }

    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) apply();
    }).observe(fig);

    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  function initAll() {
    document.querySelectorAll('.sec-safety-cta').forEach(initCtaParallax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
